export default "__VITE_ASSET__CKn_9R6l__ 100w";